import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const BulkActionsModal = ({ selectedCount, onAction, onClose }) => {
  const [actionType, setActionType] = useState('role');
  const [roleValue, setRoleValue] = useState('user');
  const [statusValue, setStatusValue] = useState('active');
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);

  const handleSubmit = async (e) => {
    e?.preventDefault();
    
    const confirmMessage = `Are you sure you want to update ${selectedCount} user(s)?`;
    if (!confirm(confirmMessage)) {
      return;
    }

    setLoading(true);
    setErrorMsg(null);
    try {
      const data = actionType === 'role' ? { role: roleValue } : { status: statusValue };
      await onAction(actionType, data);
    } catch (error) {
      console.error('Bulk action error:', error);
      setErrorMsg('Failed to perform bulk action');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[1200] p-4">
      <div className="bg-card rounded-lg shadow-elevation-lg max-w-md w-full">
        <div className="p-6 border-b border-border">
          <div className="flex items-center justify-between">
            <h2 className="text-xl font-semibold text-foreground">Bulk Actions</h2>
            <button
              onClick={onClose}
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              <Icon name="X" size={20} />
            </button>
          </div>
          <p className="text-sm text-muted-foreground mt-2">
            Apply changes to {selectedCount} selected user(s)
          </p>
        </div>

        <form onSubmit={handleSubmit} className="p-6">
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-foreground mb-2">
                Action Type
              </label>
              <Select
                value={actionType}
                onChange={(e) => setActionType(e?.target?.value)}
              >
                <option value="role">Change Role</option>
                <option value="status">Change Status</option>
              </Select>
            </div>

            {actionType === 'role' ? (
              <div>
                <label className="block text-sm font-medium text-foreground mb-2">
                  New Role
                </label>
                <Select
                  value={roleValue}
                  onChange={(e) => setRoleValue(e?.target?.value)}
                >
                  <option value="user">User</option>
                  <option value="admin">Admin</option>
                </Select>
                <p className="text-xs text-muted-foreground mt-1">
                  All selected users will be assigned this role
                </p>
              </div>
            ) : (
              <div>
                <label className="block text-sm font-medium text-foreground mb-2">
                  New Status
                </label>
                <Select
                  value={statusValue}
                  onChange={(e) => setStatusValue(e?.target?.value)}
                >
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </Select>
                <p className="text-xs text-muted-foreground mt-1">
                  All selected users will be set to this status
                </p>
              </div>
            )}
          </div>

          {errorMsg && (
            <div className="mt-4 p-3 bg-destructive/10 border border-destructive/20 rounded-md text-sm text-destructive">
              {errorMsg}
            </div>
          )}

          <div className="flex gap-3 mt-6">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              fullWidth
              disabled={loading}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              fullWidth
              disabled={loading}
              iconName={loading ? 'Loader' : 'Check'}
              iconPosition="left"
            >
              {loading ? 'Applying...' : 'Apply Changes'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BulkActionsModal;